import React from 'react';
import { Typography } from 'amphitheatre';

import UpdatePage from '../UpdatePage';

const { Paragraph } = Typography;

const Update2: React.FunctionComponent = () => {
  return (
    <UpdatePage title="Importance of Overpass Times">
      <Paragraph>
        An “overpass” is the time period when instruments aboard a satellite can
        view a place on the ground. This is actually in two directions-- you
        want to know when someone on the ground can see the spacecraft, and
        there are times when you want to know when the spacecraft can see the
        place on the ground.
      </Paragraph>
      <Paragraph>
        A person on the ground looking up might be a ground station trying to
        collect data (products) from the satellite
      </Paragraph>
      <Paragraph>
        Luckily, in your Quest for Blue, P.I.G.I. can accurately calculate
        overpass times for your spacecraft constellation and the groundstations
        you add to the scene. In P.I.G.I this is forced as a two way street “I
        can see you *and* you can see me” so keep that in mind when framing your
        problem.
      </Paragraph>
      <Paragraph>
        Another thing to consider when discussing data transfer is the data
        transfer rate, if data transfer is slow or if the data package is
        oversized, this could affect the viability of your overpasses.
        Incomplete transfers could render your proposed product useless,
        therefore ensure your hardware and calculations are optimised for the
        best chance of creating a profitable product.
      </Paragraph>
    </UpdatePage>
  );
};

export default Update2;
